<div
	class="ts1-maneuver-sidebar"
	cdkDropList
	[cdkDropListData]="maneuvers.controls"
	[cdkDropListDisabled]="readOnly"
	(cdkDropListDropped)="onDropManeuver($event)"
>
	@for (m of maneuvers.controls; track $index; let i = $index) {
		<div
			class="ts1-maneuver-item"
			[class.ts1-maneuver-item--active]="activeIndex === i"
			cdkDrag
			[cdkDragDisabled]="readOnly"
			[cdkDragStartDelay]="dragStartDelay"
			(click)="select(i)"
		>
			@if (!readOnly) {
				<button
					type="button"
					class="ts1-maneuver-item__drag-handle"
					cdkDragHandle
					aria-label="Long-press to reorder maneuver"
					(click)="$event.stopPropagation()"
				>
					<mat-icon class="!text-base">drag_indicator</mat-icon>
				</button>
			}
			<span class="ts1-maneuver-item__label truncate">{{ getManeuverLabel($any(m)) }}</span>
			@if (readOnly) {
				<span class="ts1-maneuver-action text-grey-40" aria-hidden="true">
					<mat-icon class="!text-base">visibility</mat-icon>
				</span>
			} @else if (activeIndex === i) {
				<button
					type="button"
					class="ts1-maneuver-action text-white"
					(click)="onRemove($event, i)"
					aria-label="Remove maneuver"
				>
					<mat-icon class="!text-base">delete</mat-icon>
				</button>
			} @else {
				<span class="ts1-maneuver-action text-grey-40" aria-hidden="true">
					<mat-icon class="!text-base">edit</mat-icon>
				</span>
			}
		</div>
	}

	@if (!readOnly) {
		<button type="button" class="ts1-add-maneuver-btn" (click)="onAddClick($event)">
			<span class="plus-icon">+</span>
			<span>Add Maneuver</span>
		</button>
	}
</div>
